import { combineEpics, ofType } from "redux-observable";
import { of, from, Observable, mergeMap, catchError } from "rxjs";
import { AnyAction } from "redux";
import { RootStateOrAny } from "react-redux";

import { uploadImageSuccess, uploadImageFailure, downloadFileSuccess, downloadFileFailure } from "./actions";
import { uploadImageUsecase } from "../../core/usecases/interactors/storage/upload-image";
import { downloadFileUsecase } from "../../core/usecases/interactors/storage/download-file";
import { UPLOAD_IMAGE_REQUEST, DOWNLOAD_FILE_REQUEST } from "./actionTypes";

import { errorString } from "../../utils/strings";

export const uploadApplicantImageEpic = (
  action$: Observable<AnyAction>,
  _state$: RootStateOrAny,
  {
    storageInteractor,
  }: { storageInteractor: { uploadImage: uploadImageUsecase } }
): Observable<
  ReturnType<typeof uploadImageSuccess> | ReturnType<typeof uploadImageFailure>
> =>
  action$.pipe(
    ofType(UPLOAD_IMAGE_REQUEST),
    mergeMap(({ payload: { file, fileName } }) => {
      return from(storageInteractor.uploadImage(file, fileName)).pipe(
        mergeMap((response) => {
          return of(uploadImageSuccess(response));
        }),
        catchError((error) => {
          const errorMessage = errorString(error);
          return of(uploadImageFailure(errorMessage));
        })
      );
    })
  );

export const downloadFileEpic = (
  action$: Observable<AnyAction>,
  _state$: RootStateOrAny,
  {
    storageInteractor,
  }: { storageInteractor: { downloadFile: downloadFileUsecase } }
): Observable<
  ReturnType<typeof downloadFileSuccess> | ReturnType<typeof downloadFileFailure>
> =>
  action$.pipe(
    ofType(DOWNLOAD_FILE_REQUEST),
    mergeMap(({ payload: { fileUrl, customFileName } }) => {
      return from(storageInteractor.downloadFile(fileUrl, customFileName)).pipe(
        mergeMap(() => {
          return of(downloadFileSuccess());
        }),
        catchError((error) => {
          const errorMessage = errorString(error);
          return of(downloadFileFailure(errorMessage));
        })
      );
    })
  );

export default combineEpics(
  uploadApplicantImageEpic,
  // @ts-ignore
  downloadFileEpic,
);
